import { CONSENTS, hasCookieConsentById } from "@/shared/scripts/ConsentManagementService";

(function () {
    if (!hasCookieConsentById(CONSENTS.KAMELEOON)) {
        console.debug("[Kameleoon] Skipped loading due to missing consent.");
        return;
    }

    console.debug("[Kameleoon] Consent given, loading Kameleoon...");

    var kameleoonLoadingTimeout = 1000;
    window.kameleoonQueue = window.kameleoonQueue || [];
    window.kameleoonStartLoadTime = new Date().getTime();

    if (
        !document.getElementById("kameleoonLoadingStyleSheet") &&
        !window.kameleoonDisplayPageTimeOut
    ) {
        var kameleoonS = document.getElementsByTagName("script")[0];
        var kameleoonCc =
            "* { visibility: hidden !important; background-image: none !important; }";
        var kameleoonStn = document.createElement("style");
        kameleoonStn.type = "text/css";
        kameleoonStn.id = "kameleoonLoadingStyleSheet";

        if (kameleoonStn.styleSheet) {
            kameleoonStn.styleSheet.cssText = kameleoonCc;
        } else {
            kameleoonStn.appendChild(document.createTextNode(kameleoonCc));
        }

        kameleoonS.parentNode.insertBefore(kameleoonStn, kameleoonS);

        window.kameleoonDisplayPage = function (fromEngine) {
            if (!fromEngine) {
                window.kameleoonTimeout = true;
            }
            if (kameleoonStn.parentNode) {
                kameleoonStn.parentNode.removeChild(kameleoonStn);
            }
        };

        window.kameleoonDisplayPageTimeOut = window.setTimeout(
            window.kameleoonDisplayPage,
            kameleoonLoadingTimeout
        );
    }

    const engineScript = document.createElement("script");
    engineScript.type = "text/javascript";
    engineScript.src = "//hrkn8tz1d4.kameleoon.io/engine.js";
    engineScript.async = true;
    engineScript.fetchPriority = "high";

    document.head.appendChild(engineScript);
})();
